var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExportCurve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39 13.516h-.933A3.685 3.685 0 01.772 9.831V4.956a3.685 3.685 0 013.685-3.684h11.13a3.685 3.685 0 013.686 3.684v4.885a3.675 3.675 0 01-3.675 3.675h-.943M10.022 20.31V8.269M7.107 17.381l2.915 2.928 2.916-2.928",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgExportCurve;